// extracted by mini-css-extract-plugin
export default {"movieCard":"MovieCard_movieCard__jf5v8","description":"MovieCard_description__eoHo4","year":"MovieCard_year__g-IoH","genre":"MovieCard_genre__k3oyu"};